import React, { useEffect, useState } from "react";
import { Button, DialogActions, Divider, Typography } from "@mui/material";
import { useAuth } from "../../../context/API_Client";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../reusableComponents/CustomButton";
import PaymentMethods from "./PaymentMethods";
import SmallModal from "../../../reusableComponents/modals/SmallModal";
import "./gatewayStyle.css";
import { customToast } from "../../../reusableComponents/customToaster/customToast";

const ReviewConfigurations = (props) => {
  const { savePspConfigs } = useAuth();
  const [allCorrect, setAllCorrect] = useState(true);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    for (let i = 0; i < props?.paymentOptionsIds?.length; i++) {
      for (let j = 0; j < props?.paymentOptionsIds?.length; j++) {
        if (
          props?.payload[j]?.pspCode === props?.paymentOptionsIds[i]?.pspCode &&
          props?.payload[0]?.rules?.configs[0]
        ) {
          for (
            let k = 1;
            k <=
            Object.keys(props?.payload[0]?.rules?.configs[0]["BusinessUnit"])
              ?.length;
            k++
          ) {
            let Configs = {};
            let newfield;
            Object.keys(props?.payload[0]?.rules?.configs[0]).map(
              (fieldName) => {
                if (fieldName !== "BusinessUnit") {
                  newfield = {
                    [fieldName]:
                      props?.payload[0]?.rules?.configs[0][fieldName][k],
                  };
                  Configs = { ...Configs, ...newfield };
                }
              }
            );
            savePspConfigs(
              props?.payload[j]?.rules?.configs[0]["BusinessUnit"][k],
              props?.paymentOptionsIds[i]?.pspCode,
              props?.payload[j]?.rules?.countryCode,
              {
                configs: Configs,
                currencyCodes: props?.payload[j]?.rules?.currencyCodes[0],
                countryCode: props?.payload[j]?.rules?.countryCode,
                paymentMethodIds: props?.paymentOptionsIds[i]?.Ids,
              },
              function (data) {
                if (
                  i == props?.paymentOptionsIds.length - 1 &&
                  k ==
                  Object.keys(
                    props?.payload[0]?.rules?.configs[0]["BusinessUnit"]
                  )?.length &&
                  allCorrect
                ) {
                  navigate("/payment_gateway_configurations");
                  customToast("success", "high", "Gateway Added");
                }
              },
              function (errorMsg) {
                setAllCorrect(false);
                customToast("error", "high", errorMsg);
              }
            );
          }
        }
      }
    }

    handleClose();
  };

  const handleBack = () => {
    if (props.supportedOptions?.length > 0) props.setValue(0);

    props.setPreview(false);
  };

  const [toggleCard, setToggleCard] = useState(false);
  const [toggleWallet, setToggleWallet] = useState(false);
  const [toggleBNPL, setToggleBNPL] = useState(false);
  const [toggleNetBanking, setToggleNetBanking] = useState(false);
  const [toggleUpi, setToggleUpi] = useState(false);
  const [toggleCrypto, setToggleCrypto] = useState(false);
  const [togglePaynow, setTogglePaynow] = useState(false);
  const [toggleEmi, setToggleEmi] = useState(false);

  return (
    <div style={{ padding: "20px" }}>
      <Typography style={{ fontSize: "21px" }}>Preview</Typography>
      <div style={{ gap: "12px", display: "flex", flexDirection: "column" }}>
        <div style={{ overflowY: "auto", height: "49vh" }}>
          <div>
            {props?.paymentOptions.map((obj, index) => (
              <>
                <Typography
                  className="previewHeading"
                  style={{ marginTop: "16px" }}
                >
                  Selected Gateway
                </Typography>
                <div style={{ display: "flex", marginTop: "6px" }}>
                  <img src={obj?.logoUrl} style={{ marginLeft: "-3px" }} width={24} />
                  <Typography style={{ paddingTop: "-2px" }}>
                    {obj?.title}
                  </Typography>
                </div>
                <Typography
                  className="previewHeading"
                  style={{ marginTop: "16px" }}
                >
                  Payment Options
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    marginTop: "12px",
                  }}
                >
                  {obj?.Cards > 0 && (
                    <PaymentMethods
                      type={obj.cardSelects[0]?.type}
                      typeTitle={obj.cardSelects[0]?.typeTitle}
                      count={obj?.Cards}
                      toggle={toggleCard}
                      setToggle={setToggleCard}
                      selects={obj?.cardSelects}
                    />
                  )}

                  {obj?.Wallet > 0 && (
                    <PaymentMethods
                      type={obj.walletSelects[0]?.type}
                      typeTitle={obj.walletSelects[0]?.typeTitle}
                      count={obj?.Wallet}
                      toggle={toggleWallet}
                      setToggle={setToggleWallet}
                      selects={obj?.walletSelects}
                    />
                  )}

                  {obj?.NetBanking > 0 && (
                    <PaymentMethods
                      type={obj.NetBankingSelects[0]?.type}
                      typeTitle={obj.NetBankingSelects[0]?.typeTitle}
                      count={obj?.NetBanking}
                      toggle={toggleNetBanking}
                      setToggle={setToggleNetBanking}
                      selects={obj?.NetBankingSelects}
                    />
                  )}

                  {obj?.BuyNowPayLater > 0 && (
                    <PaymentMethods
                      type={obj.bnplSelects[0]?.type}
                      typeTitle={obj.bnplSelects[0]?.typeTitle}
                      count={obj?.BuyNowPayLater}
                      toggle={toggleBNPL}
                      setToggle={setToggleBNPL}
                      selects={obj?.bnplSelects}
                    />
                  )}

                  {obj?.UPI > 0 && (
                    <PaymentMethods
                      type={obj.upiSelects[0]?.type}
                      typeTitle={obj.upiSelects[0]?.typeTitle}
                      count={obj?.UPI}
                      toggle={toggleUpi}
                      setToggle={setToggleUpi}
                      selects={obj?.upiSelects}
                    />
                  )}

                  {obj?.EMI > 0 && (
                    <PaymentMethods
                      type={obj.emiSelects[0]?.type}
                      typeTitle={obj.emiSelects[0]?.typeTitle}
                      count={obj?.EMI}
                      toggle={toggleEmi}
                      setToggle={setToggleEmi}
                      selects={obj?.emiSelects}
                    />
                  )}

                  {obj?.Crypto > 0 && (
                    <PaymentMethods
                      type={obj.cryptoSelects[0]?.type}
                      typeTitle={obj.cryptoSelects[0]?.typeTitle}
                      count={obj?.Crypto}
                      toggle={toggleCrypto}
                      setToggle={setToggleCrypto}
                      selects={obj?.cryptoSelects}
                    />
                  )}

                  {obj?.Paynow > 0 && (
                    <PaymentMethods
                      type={obj.PaynowSelects[0]?.type}
                      typeTitle={obj.PaynowSelects[0]?.typeTitle}
                      count={obj?.Paynow}
                      toggle={togglePaynow}
                      setToggle={setTogglePaynow}
                      selects={obj?.PaynowSelects}
                    />
                  )}
                </div>
                {index < props.paymentOptions.length - 1 && <Divider></Divider>}
              </>
            ))}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "0px",
            justifyContent: "end",
            width: "100%",
            gap: "8px",
          }}
        >
          <CustomButton
            text={"Back"}
            type={"primary"}
            size={"xs"}
            onClick={handleBack}
          />

          <CustomButton
            text={"Submit"}
            variant={"contained"}
            type={"primary"}
            size={"xs"}
            onClick={handleOpen}
          />
        </div>
      </div>

      <SmallModal
        toggleDialog={open}
        headerText={"Save Gateway"}
        subHeaderText={
          "Please note once you save the gateway, the credentials given by you cannot be modified further. Kindly review the credentials before submitting"
        }
        outlinedBtnText={"No"}
        outlinedBtnFunction={handleClose}
        filledBtnText={"Yes"}
        filledBtnFunction={handleSubmit}
      />
    </div>
  );
};

export default ReviewConfigurations;
